import { render, staticRenderFns } from "./JobView.vue?vue&type=template&id=54e9eb1c&scoped=true&"
import script from "./JobView.vue?vue&type=script&lang=js&"
export * from "./JobView.vue?vue&type=script&lang=js&"
import style0 from "./JobView.vue?vue&type=style&index=0&id=54e9eb1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e9eb1c",
  null
  
)

export default component.exports